import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger, LoggingService } from 'ionic-logging-service';
import { Observable } from 'rxjs';
import { delay, finalize, retryWhen, take, tap } from 'rxjs/operators';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class VersionControlService {

    // private versionControl: string = '/assets/json/language/supported-languages/supported-languages.json';
    private versionControl: string = '/assets/json/release-app-version.json';  // change for new version check
    private httpErrorResponse: HttpErrorResponse;
    private logger: Logger;

  constructor(
    public environmentService: EnvironmentService,
    private httpClient: HttpClient,
    private loggingService: LoggingService,
  ) {
    this.logger = this.loggingService.getLogger("[VersionControlService]");
    const methodName = "ctor";
    this.logger.entry(methodName);
  }

  public getCurrentAppVersion(APP_ENDPOINT): Observable<any> {
    this.logger.info('getCurrentAppVersion()');
    return new Observable((observer) => {
      let getVersionUrl = APP_ENDPOINT + this.versionControl;
      this.httpClient.get<any>(getVersionUrl)
      .pipe(retryWhen(error => error.pipe(
        delay(1000),
        take(3),
        tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
        finalize(() => {
          observer.error(this.httpErrorResponse);
          observer.complete();
        })
      )))
      .subscribe((currentVersion) => {
        observer.next(currentVersion);
        observer.complete();
      });
    });
  }
}